// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sf3pqYNd{display:flex;flex-direction:column;gap:.2rem}.DaeaFQyh{display:grid;grid-template:\"a1 a2 a3 a3\" \"a4 a4 a3 a3\" \"a4 a4 a3 a3\" \"a5 a5 a6 a6\" \"a5 a5 a6 a6\";grid-template-rows:repeat(4,10vw);grid-gap:.2rem;gap:.2rem}.AoQrrmYJ{border-radius:8px;overflow:hidden;transition:transform .15s}@media(hover:hover){.AoQrrmYJ:hover{transform:scale(.99)}}@media(hover:none){.AoQrrmYJ:active{transform:scale(.99)}}.qOnJOWDF{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "sf3pqYNd",
	"containerGrid": "DaeaFQyh",
	"item": "AoQrrmYJ",
	"photo": "qOnJOWDF"
};
module.exports = ___CSS_LOADER_EXPORT___;
